if (!customElements.get('mega-menu-style-6')) {
  class MegaMenuStyle6 extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-megamenu-style-6-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-megamenu-style-6-panel]'));
      this.mobileToggles = Array.from(
        this.querySelectorAll('[data-megamenu-style-6-mobile-toggle]')
      );
      this.mobilePanels = Array.from(
        this.querySelectorAll('[data-megamenu-style-6-mobile-panel]')
      );

      this.tabs.forEach((tab) => {
        tab.addEventListener('mouseenter', () => this.activate(tab));
        tab.addEventListener('focus', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
      });

      this.mobileToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => this.activateMobile(toggle));
      });
    }

    activateMobile(toggle) {
      const panelId = toggle.getAttribute('aria-controls');
      const expanded = toggle.getAttribute('aria-expanded') === 'true';

      this.mobileToggles.forEach((item) => {
        const active = item === toggle && !expanded;
        item.setAttribute('aria-expanded', active ? 'true' : 'false');
        item.closest('.megamenu-style-6__mobile-category')?.classList.toggle('is-active', active);
      });

      this.mobilePanels.forEach((panel) => {
        panel.hidden = expanded || panel.id !== panelId;
      });
    }

    activate(tab) {
      const panelId = tab.getAttribute('aria-controls');

      this.tabs.forEach((item) => {
        const active = item === tab;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });
    }

    onKeydown(event, tab) {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

      event.preventDefault();
      const currentIndex = this.tabs.indexOf(tab);
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      const nextIndex = (currentIndex + direction + this.tabs.length) % this.tabs.length;
      this.tabs[nextIndex].focus();
    }
  }

  customElements.define('mega-menu-style-6', MegaMenuStyle6);
}
